import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseWorkflowModel, WorkflowCspComponent } from '../workflow-csp.component';
import { Block } from 'src/app/phonenumber/phonenumber.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Model } from 'src/app/app.model';
import { BuyService } from 'src/app/buy/buy.service';
import { SubscriptionService } from 'src/app/subscription/subscription.service';
import { MessageService } from 'primeng/api';
import { I18NextService } from 'angular-i18next';
import { CompanyService } from 'src/app/company/company.service';
import { PhonenumberService } from 'src/app/phonenumber/phonenumber.service';
import { HttpClient } from '@angular/common/http';
import { WorkflowCspService } from '../workflow-csp.service';
import { Company } from 'src/app/company/company.model';
import { PaymentDetails } from 'src/app/buy/buy.model';
import { runInAction } from 'mobx';
import { firstValueFrom } from 'rxjs';

type WorkflowModel = BaseWorkflowModel & {
  block: Block
}

@Component({
  selector: 'app-workflow-csp-one-cancel-phonenumber',
  templateUrl: './workflow-csp-one-cancel-phonenumber.component.html',
  standalone: false
})
export class WorkflowCspOneCancelPhonenumberComponent extends WorkflowCspComponent<WorkflowModel> implements OnInit, OnDestroy {

  get workflowName(): string {
    return 'cancel-phonenumber';
  }

  private blockId = 0;

  constructor(protected router: Router,
    protected m: Model,
    protected route: ActivatedRoute,
    protected buyService: BuyService,
    protected subscriptionService: SubscriptionService,
    protected messageService: MessageService,
    protected i18next: I18NextService,
    protected companyService: CompanyService,
    protected cspService: WorkflowCspService,
    protected phonenumberService: PhonenumberService,
    protected http: HttpClient) {
    super(route, router, subscriptionService, buyService, m, http, cspService, companyService);
  }

  async ngOnInit() {
    await super.ngOnInit();

    if (!this.checkSubscriptionValid) {
      this.resetWorkflow();
      return;
    }

    this.blockId = +(this.route.snapshot.paramMap.get('bid') ?? 0);
    const block = this.m.phonenumber.blocks.find(block => block.id === this.blockId);
    if (!block) {
      this.resetWorkflow();
      return;
    }
    this.model.block = block;

    this.initialized = true;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  
  // step 1: confirm cancellation
  public onCancellationConfirmed(s: any) {
    this.navigate([this.blockId, 'address']);
  }
  
  // step 2: invoice address
  public onInvoiceAddressBack() {
    this.navigate([this.blockId, 'confirm']);
  }
  
  public onInvoiceAddress(company: Company) {
    this.model.company = company;
    if (this.isSepa && !this.model.company.hasBankAccount) {
      this.navigate([this.blockId, 'payment']);
      return;
    }
    this.createOrderAndCheckout();
  }

  // step 3: payment
  public onPaymentMethodBack() {
    this.navigate([this.blockId, 'address']);
  }
  
  public async onPaymentMethod(payment: PaymentDetails) {
    await this.setPaymentDetails(payment);
    this.createOrderAndCheckout();
  }
  
  private async createOrderAndCheckout() {
    await this.createOffer();
    this.navigate([this.blockId, 'checkout-summary']);
  }
  
  private async createOffer() {
    // if a saleOrder exists --> return, otherwise create one
    if (this.model.saleOrder?.name) {
      return;
    }
  
    const saleOrder = await firstValueFrom(this.workflowCspService.oneApplianceCreateCancelPhonenumberOrder(this.model.subscription?.appliance_id, this.blockId));
    runInAction(() => {
      this.model.saleOrder = saleOrder;
    });
  }
  
  // step : 4 confirm order
  public onSummaryBack() {
    if (this.isSepa && !this.model.company?.hasBankAccount) {
      this.navigate([this.blockId, 'payment']);
    } else {
      this.navigate([this.blockId, 'address']);
    }
  }
  
  public onSummaryBuy() {
    this.buyService.confirmUpgrade().subscribe(
      (saleOrder: any) => {
        this.navigate([this.blockId, 'complete']);
      }
    );
  }
  
  public onComplete(): void {
    this.resetWorkflow();
  }

}
